import type {Spec} from 'immutability-helper';

import type {SelectionRestoreData} from 'notebook/mediocre/selection/SelectionStore';
import type {CidIdMap, CidNotePartProvenanceIdMap} from 'notebook/notes/NoteConstants';
import type {MultidocTableOpMap} from 'notebook/tables/excess/ops/TableOpConstants';
import type {
  BioentityServerNote,
  BioentityServerNoteVersion,
  FromServerNote,
  Note,
} from 'notebook/util/NoteUtilConstants';
import type {Response} from 'notifications';

export interface NoteBulkUpdateItem {
  fileId: string;
  note: BioentityServerNote;
}

export const NOTE_EVENT_PAYLOADS = {
  SELECTION_SET: {} as {data: SelectionRestoreData},

  NOTE_BULK_UPDATE: {} as {items: Array<NoteBulkUpdateItem>},
  NOTE_CLOSE: {} as {fileId: string},
  NOTE_FETCH_VERSIONS: {} as {fileId: string},
  NOTE_FETCH_VERSIONS_COMPLETED: {} as {fileId: string; versions: Array<BioentityServerNoteVersion>},
  NOTE_FETCH_VERSIONS_FAILED: {} as {fileId: string},
  NOTE_LOAD: {} as {fileId: string; note: FromServerNote},
  NOTE_LOAD_VERSION: {} as {fileId: string; versionId: string},
  NOTE_LOAD_VERSION_COMPLETED: {} as {
    fileId: string;
    versionId: string;
    version: BioentityServerNoteVersion;
  },
  NOTE_LOAD_VERSION_FAILED: {} as {fileId: string; versionId: string},
  NOTE_REGISTER_OBJECTS: {} as {fileId: string; cidIdMap: CidIdMap},
  NOTE_REPLACE: {} as {fileId: string; note: Note; restoreData: SelectionRestoreData},
  NOTE_SAVE: {} as {fileId: string},
  NOTE_SAVE_COMPLETED: {} as {
    fileId: string;
    savedVersion: number;
    versionId: string | number;
    cidIdMap: CidIdMap;
    cidNotePartProvenanceIdMap?: CidNotePartProvenanceIdMap;
  },
  NOTE_SAVE_FAILED: {} as {fileId: string; error: Response},
  NOTE_UPDATE: {} as {
    fileId: string;
    op: Spec<Note>;
    cidIdMap: CidIdMap;
    bumpVersion?: boolean;
    multidocTableOp?: MultidocTableOpMap;
  },
} as const;

export type NoteEventPayload = typeof NOTE_EVENT_PAYLOADS;
